import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=218411cf&scoped=true"
import script from "./ReportCard.vue?vue&type=script&lang=ts"
export * from "./ReportCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=218411cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218411cf",
  null
  
)

export default component.exports